export default "__VITE_ASSET__DMgxQI9M__"